<svg
	*ngIf="config"
	[ngSwitch]="type"
	[attr.class]="stateArray.join(' ') + ' ' + size + ' ' + svgStyleClass + ' svg-icon--' + type"
	[attr.height]="config.dimensions.height ?? config.dimensions.viewBoxHeight"
	[attr.viewBox]="viewBox"
	[attr.width]="config.dimensions.width ?? config.dimensions.viewBoxWidth"
	[ngClass]="{
		'stroke-colored': strokeColor,
		'fill-colored': fillColor
	}"
	preserveAspectRatio="xMidYMin slice"
	xmlns="http://www.w3.org/2000/svg"
>

	<ng-container *ngSwitchCase="svgTypes.ACCOUNTS" [ngTemplateOutlet]="accountsTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ACKNOWLEDGE" [ngTemplateOutlet]="acknowledgeTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ACTIVATIONS" [ngTemplateOutlet]="activationsTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ARCHIVING" [ngTemplateOutlet]="archivingTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ARROW_DOWN" [ngTemplateOutlet]="arrowDownTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ARROW_LEFT" [ngTemplateOutlet]="arrowLeftTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ARROW_RIGHT" [ngTemplateOutlet]="arrowRightTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ARROW_UP" [ngTemplateOutlet]="arrowUpTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ASSIGN" [ngTemplateOutlet]="assignTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.AUTHORITIES_BADGE" [ngTemplateOutlet]="authoritiesBadgeTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.BUSINESS_PREMISES" [ngTemplateOutlet]="businessPremisesTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.CHECK" [ngTemplateOutlet]="checkTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.CHECKERED_FLAG" [ngTemplateOutlet]="checkeredFlagTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.CHEVRON_LEFT" [ngTemplateOutlet]="chevronLeftTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.CHEVRON_RIGHT" [ngTemplateOutlet]="chevronRightTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.CLEAR" [ngTemplateOutlet]="clearTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.COMPLAIN" [ngTemplateOutlet]="complainTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.CONTACT" [ngTemplateOutlet]="contactTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.CONTRACT" [ngTemplateOutlet]="contractTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.DASHBOARD" [ngTemplateOutlet]="dashboardTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.DATACENTER" [ngTemplateOutlet]="datacenterTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.DECOMMISSION" [ngTemplateOutlet]="decommissionTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.DEFAULT" [ngTemplateOutlet]="defaultTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.DETAILS" [ngTemplateOutlet]="detailsTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.DOCUMENTATION" [ngTemplateOutlet]="documentationTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.DOWNLOAD" [ngTemplateOutlet]="downloadTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ELSTER_SUBMIT" [ngTemplateOutlet]="elsterSubmitTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ERROR" [ngTemplateOutlet]="errorTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ERS" [ngTemplateOutlet]="ersTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.FILTER" [ngTemplateOutlet]="filterTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.IMPORT" [ngTemplateOutlet]="importTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.KEYWORD" [ngTemplateOutlet]="keywordTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.LICENCES" [ngTemplateOutlet]="licencesTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.LOCKED" [ngTemplateOutlet]="lockedTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.MAGNIFIER" [ngTemplateOutlet]="magnifierTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.MANAGE_TENANT" [ngTemplateOutlet]="manageTenantTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.MANIFEST" [ngTemplateOutlet]="manifestTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.MANIFEST_ASSIGN" [ngTemplateOutlet]="manifestAssignTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.MANUAL_EXPORT" [ngTemplateOutlet]="manualExportTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.MESSAGE" [ngTemplateOutlet]="messageTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.MY_ACCOUNT" [ngTemplateOutlet]="myAccountTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.NO_ASSIGNMENT" [ngTemplateOutlet]="noAssignmentTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.NO_ICON" [ngTemplateOutlet]="noIconTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.NOTIFICATION_BELL" [ngTemplateOutlet]="notificationBellTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.ORGANIZATION" [ngTemplateOutlet]="organizationsTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.PATCH" [ngTemplateOutlet]="patchTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.REACTIVATE" [ngTemplateOutlet]="reactivateTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.RELOAD" [ngTemplateOutlet]="reloadTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.RESET" [ngTemplateOutlet]="resetTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.RETURN" [ngTemplateOutlet]="returnTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.REVERT" [ngTemplateOutlet]="revertTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.SIGNATURES" [ngTemplateOutlet]="signaturesTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.SIGNATURE_PACKAGES" [ngTemplateOutlet]="signaturePackageTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.STAR" [ngTemplateOutlet]="starTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.STATUS" [ngTemplateOutlet]="statusTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.STRUCTURE" [ngTemplateOutlet]="structureTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.SUSPENDED" [ngTemplateOutlet]="suspendedTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.TENANTS" [ngTemplateOutlet]="tenantsTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.TRANSACTIONS" [ngTemplateOutlet]="transactionsTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.TSS" [ngTemplateOutlet]="tssTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.TSS_MODE_CLOUD" [ngTemplateOutlet]="tssModeCloudTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.TSS_MODE_OFFLINE" [ngTemplateOutlet]="tssModeOfflineTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.TSS_MODE_TOKEN" [ngTemplateOutlet]="tssModeTokenTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.UNLOCKED" [ngTemplateOutlet]="unlockedTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.UPLOAD" [ngTemplateOutlet]="uploadTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.USAGE" [ngTemplateOutlet]="usageTpl"></ng-container>

	<ng-container *ngSwitchCase="svgTypes.USERS" [ngTemplateOutlet]="usersTpl"></ng-container>

</svg>

<!-- ######################### TEMPLATES ######################### -->
<ng-template #accountsTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
		transform="translate(0)"
	>
		<svg:g
			transform="translate(3 4)"
		>

			<svg:path
				class="stroke-width-2 strokeable"
				d="M1668.984,893.4h0a2.5,2.5,0,0,1-2.5-2.5h0a2.5,2.5,0,0,1,2.5-2.5h0a2.5,2.5,0,0,1,2.5,2.5h0A2.5,2.5,0,0,1,1668.984,893.4Z"
				stroke-linecap="round"
				stroke-linejoin="round"
				transform="translate(-1655.745 -891.395)"
			/>

			<svg:path
				class="stroke-width-2 strokeable"
				d="M1659.983,908.4h0a2.5,2.5,0,0,1-2.5-2.5h0a2.5,2.5,0,0,1,2.5-2.5h0a2.5,2.5,0,0,1,2.5,2.5h0A2.5,2.5,0,0,1,1659.983,908.4Z"
				stroke-linecap="round"
				stroke-linejoin="round"
				transform="translate(-1659.483 -881.397)"
			/>

			<svg:path
				class="stroke-width-2 strokeable"
				d="M1677.985,908.4h0a2.5,2.5,0,0,1-2.5-2.5h0a2.5,2.5,0,0,1,2.5-2.5h0a2.5,2.5,0,0,1,2.5,2.5h0A2.5,2.5,0,0,1,1677.985,908.4Z"
				stroke-linecap="round"
				stroke-linejoin="round"
				transform="translate(-1652.485 -881.397)"
			/>

			<svg:circle
				class="stroke-width-2 strokeable"
				cx="6"
				cy="6"
				r="6"
				stroke-linecap="round"
				stroke-linejoin="round"
				transform="translate(7.501 7.5)"
			/>

			<svg:path
				class="stroke-width-2 strokeable"
				d="M1.469.423,7.118,5.157"
				stroke-linecap="round"
				transform="translate(16.5 17.5)"
			/>

			<svg:line
				class="stroke-width-2 strokeable"
				stroke-linecap="round"
				stroke-linejoin="round"
				transform="translate(13.5 2.5)"
				y1="5"
			/>

			<svg:path
				class="stroke-width-2 strokeable"
				d="M.906,6.869,6.639,2.209"
				stroke-linecap="round"
				transform="translate(1.955 15.5)"
			/>

			<svg:circle
				class="stroke-width-2 fillable"
				cx="1.5"
				cy="1.5"
				r="1.5"
				transform="translate(12 12)"
			/>
		</svg:g>
	</svg:g>

</ng-template>

<ng-template #acknowledgeTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		stroke-linecap="round"
		stroke-linejoin="round"
	>
		<!-- background & outline -->
		<svg:path
			class="strokeable stroke-width-2"
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'stroke': strokeColor,
				'fill': fillColor
			}"
			d="m11.2 1.38a1 1 0 0 1 1.52 0l1.88 2.18a1 1 0 0 0 0.912 0.335l2.82-0.443a1 1 0 0 1 1.16 0.967l0.061 2.94a1 1 0 0 0 0.476 0.831l2.48 1.52a1 1 0 0 1 0.26 1.47l-1.82 2.3a1 1 0 0 0-0.164 0.938l0.936 2.79a1 1 0 0 1-0.751 1.3l-2.82 0.567a1 1 0 0 0-0.737 0.623l-1.04 2.72a1 1 0 0 1-1.42 0.516l-2.5-1.39a1 1 0 0 0-0.975 0l-2.5 1.39a1 1 0 0 1-1.42-0.516l-1.04-2.72a1 1 0 0 0-0.737-0.623l-2.82-0.567a1 1 0 0 1-0.751-1.3l0.936-2.79a1 1 0 0 0-0.164-0.938l-1.82-2.3a1 1 0 0 1 0.26-1.47l2.47-1.52a1 1 0 0 0 0.476-0.831l0.061-2.94a1 1 0 0 1 1.16-0.967l2.82 0.443a1 1 0 0 0 0.912-0.335z"
		/>

		<!-- checkmark -->
		<svg:path
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m7.61 12 3.58 3.41 5.55-5.7"
		/>
	</svg:g>
</ng-template>

<ng-template #activationsTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="
		{
			'strokeable': strokeable
		}"
		transform="translate(-95 -1514.001)"
	>

		<!--circle -->
		<svg:circle
			class="stroke-width-2 strokeable"
			r="6"
			transform="translate(112 1526)"
		/>

		<!-- outer ellipse -->
		<svg:rect
			class="stroke-width-2 strokeable"
			height="12"
			rx="6"
			stroke-linejoin="round"
			transform="translate(96 1520)"
			width="22"
		/>
	</svg:g>
</ng-template>

<ng-template #archivingTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
		transform="translate(0.359)"
	>
		<svg:g transform="translate(1 5)">

			<!-- upper part -->
			<svg:path
				class="stroke-width-2 strokeable"
				d="M333.579,1048.357l-4.256-5.836H315.917l-4.259,5.836"
				stroke-linecap="round"
				stroke-linejoin="round"
				transform="translate(-311.62 -1042.521)"
			/>

			<!-- lower part -->
			<svg:path
				class="stroke-width-2 strokeable"
				d="M326.489,1048.516v2.06a1.594,1.594,0,0,1-1.665,1.511h-4.539a1.594,1.594,0,0,1-1.665-1.511v-2.06h-7v7.527a1.767,1.767,0,0,0,1.841,1.67h18.317a1.767,1.767,0,0,0,1.841-1.67v-7.527Z"
				stroke-linecap="round"
				stroke-linejoin="round"
				transform="translate(-311.62 -1043.121)"
			/>
		</svg:g>
	</svg:g>
</ng-template>

<ng-template #arrowDownTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'strokeable': strokeable
		}"
	>
		<!-- arrowhead -->
		<svg:line
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="8"
			x2="8"
			y1="3"
			y2="12"
			stroke-linecap="round"
		/>
		<!-- shaft -->
		<svg:path
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m12 9-4 4-4-4"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg:g>
</ng-template>

<ng-template #arrowLeftTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'strokeable': strokeable
		}"
	>
		<!-- arrowhead -->
		<svg:line
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="13"
			x2="4"
			y1="8"
			y2="8"
			stroke-linecap="round"
		/>

		<!-- shaft -->
		<svg:path
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m7 12-4-4 4-4"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg:g>
</ng-template>

<ng-template #arrowRightTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'strokeable': strokeable
		}"
	>
		<!-- arrowhead -->
		<svg:line
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="3"
			x2="12"
			y1="8"
			y2="8"
			stroke-linecap="round"
		/>

		<!-- shaft -->
		<svg:path
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m9 4 4 4-4 4"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg:g>
</ng-template>

<ng-template #arrowUpTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'strokeable': strokeable
		}"
	>
		<!-- arrowhead -->
		<svg:line
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="8"
			x2="8"
			y1="13"
			y2="4"
			stroke-linecap="round"
		/>

		<!-- shaft -->
		<svg:path
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m4 7 4-4 4 4"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg:g>
</ng-template>

<ng-template #assignTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'strokeable': strokeable
		}"
	>
		<!-- arrow -->
		<svg:g
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<!-- shaft -->
			<svg:path
				class="stroke-width-2 strokeable"
				[ngStyle]="{
					'stroke': strokeColor
				}"
				d="m1.111 12.39h8.296"
			/>

			<!-- arrowhead -->
			<svg:path
				class="stroke-width-2 strokeable"
				[ngStyle]="{
					'stroke': strokeColor
				}"
				d="m5.79 16.54 4.148-4.148-4.148-4.148"
			/>
		</svg:g>

		<!-- circle -->
		<svg:circle
			class="stroke-width-2 strokeable"
			[ngClass]="{
			'fillable': fillable
			}"
			[ngStyle]="{
				'stroke': strokeColor,
				'fill': fillColor
			}"
			cx="18.74"
			cy="12.39"
			r="5.185"
		/>
	</svg:g>
</ng-template>

<ng-template #authoritiesBadgeTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		class="strokeable"
		[ngClass]="{
			'fillable': fillable
		}"
	>
		<!-- left ribbon -->
		<svg:path
			class="stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor,
				'fill': fillColor
			}"
			d="m11.33 14.95-3.971 7.963-0.8438-3.384-3.381 1.293 4.012-7.707"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>

		<!-- right ribbon -->
		<svg:path
			class="stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor,
				'fill': fillColor
			}"
			d="m13.2 14.95 3.97 7.963 0.8445-3.387 3.381 1.293-4.012-7.707"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>

		<!-- badge plate -->
		<svg:circle
			class="stroke-width-2"
			[ngStyle]="{
			'stroke': strokeColor,
			'fill': fillColor
		}"
			cx="12"
			cy="8"
			r="7"
		/>
	</svg:g>
</ng-template>

<ng-template #businessPremisesTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
		transform="translate(0.106)"
	>
		<svg:path
			class="stroke-width-2 strokeable"
			d="M145.5,1812.553l0,15.806-24-.109v-15.237"
			stroke-linecap="round"
			transform="translate(-117.5 -1802.359)"
			stroke-linejoin="round"
		/>

    <svg:path
			class="stroke-width-2 strokeable"
			d="M9,10.688v-9H0"
			stroke-linejoin="round"
			transform="translate(13 15.313)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M2.761,7.387l19.315-5.01,10.568,5.01"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-1.647 3.313)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M2.761,7.731v-8h4v8"
			stroke-linejoin="round"
			transform="translate(7.239 17.269)"
		/>
  </svg:g>
</ng-template>

<ng-template #checkTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g [ngClass]="{
		'fillable': fillable,
		'strokeable': strokeable
	}">
		<svg:path
			d="M9.823,15.694A.66.66,0,0,1,9.285,16a.626.626,0,0,1-.445-.2L5.269,12.2a1.066,1.066,0,0,1-.112-1.265.62.62,0,0,1,1-.14L9.2,13.86l4.551-6.553a.618.618,0,0,1,1.008-.084,1.07,1.07,0,0,1,.066,1.27Z"
			transform="translate(-5 -7.001)"/>
	</svg:g>
</ng-template>

<ng-template #checkeredFlagTpl xmlns:svg="http://www.w3.org/2000/svg">
	<!-- flag background -->
  <svg:path
		class="stroke-width-0"
		[ngClass]="{
			'fillable': fillable
		}"
		[ngStyle]="{
			'fill': fillColor
		}"
		d="m4 16c0.309-0.418 0.746-0.744 1.25-0.889 0.519-0.151 1.07-0.131 1.61-0.0483 0.114 0.0176 0.228 0.0376 0.342 0.0595 1.28 0.249 2.5 0.762 3.74 1.19h1e-6c0.16 0.0546 0.32 0.108 0.48 0.161 1.43 0.47 2.89 0.86 4.39 0.929 0.153 7e-3 0.307 0.01 0.46 0.0091 1.67-0.0103 3.34-0.491 4.74-1.41 0.122-3.75 0.122-7.42-2.5e-4 -11-1.36 0.977-3.1 1.37-4.77 1.23-1e-6 -1e-7 -1e-6 -2e-7 -1e-6 -2e-7 -0.154-0.0123-0.307-0.028-0.46-0.0468-1.49-0.184-2.94-0.665-4.36-1.16-0.16-0.0557-0.32-0.113-0.48-0.17-1e-6 -1e-7 -1e-6 -2e-7 -1e-6 -3e-7 -1.24-0.444-2.49-0.907-3.79-1.05-0.116-0.0127-0.232-0.0205-0.349-0.0234h-9e-7c-0.545-0.0132-1.1 0.0817-1.59 0.292-0.473 0.202-0.893 0.509-1.2 0.929"
	/>
	<!-- checkered pattern -->
	<svg:g
		class="stroke-width-0 fillable"
	>
		<svg:path
			[ngStyle]="{
				'fill': strokeColor
			}"
			d="m7.89 4.95c1.01 0.203 1.99 0.568 2.97 0.917-0.0092 1.04-0.0152 2.08-0.018 3.12-0.927-0.331-1.86-0.697-2.83-0.915-0.0218-1.04-0.0616-2.08-0.119-3.12z"
		/>
		<svg:path
			[ngStyle]="{
				'fill': strokeColor
			}"
			d="m4.85 8.2c0.188-0.0973 0.401-0.18 0.636-0.247h1e-7c0.682-0.12 1.25-0.115 1.65-0.0302 0.0775 0.0122 0.153 0.0234 0.227 0.0334 0.217 0.032 0.431 0.0729 0.644 0.121 0.0218 1.04 0.0257 2.07 0.0116 3.1-0.212-0.052-0.425-0.0975-0.641-0.135-0.0731-0.0126-0.148-0.0271-0.225-0.0433-0.394-0.104-0.965-0.14-1.65-0.0362h-2e-7c-0.237 0.0621-0.452 0.142-0.642 0.238 0.00697-1.01 0.00507-2.01-0.00568-3z"
		/>
		<svg:path
			[ngStyle]="{
				'fill': strokeColor
			}"
			d="m8.02 11.2c0.966 0.238 1.89 0.611 2.82 0.939 0.0036 1.04 0.0103 2.08 0.0203 3.13-0.972-0.338-1.94-0.728-2.94-0.987 0.05-1.02 0.0821-2.05 0.0962-3.08z"
		/>
		<svg:path
			[ngStyle]="{
				'fill': strokeColor
			}"
			d="m13.8 6.83c0.612 0.16 1.23 0.289 1.86 0.364 0.149 0.019 0.299 0.0352 0.451 0.0485 0.268 0.0227 0.537 0.0317 0.806 0.0268-0.0588 1.02-0.0972 2.03-0.115 3.04-0.276 0.0064-0.55-0.0019-0.823-0.0248-0.147-0.0135-0.292-0.0294-0.435-0.0474-0.622-0.0653-1.23-0.183-1.83-0.334 0.0137-1.03 0.043-2.05 0.0879-3.07z"
		/>
		<svg:path
			[ngStyle]="{
				'fill': strokeColor
			}"
			d="m13.8 13c0.601 0.14 1.21 0.246 1.84 0.298 0.143 0.0148 0.288 0.0272 0.436 0.0371 0.273 0.0167 0.547 0.0192 0.822 0.0074 0.0231 1.01 0.0666 2.02 0.131 3.02-0.267 0.0211-0.535 0.0297-0.802 0.0257-0.151-0.0024-0.302-0.0083-0.452-0.0176-0.632-0.0354-1.26-0.127-1.87-0.257-0.0486-1.04-0.0816-2.08-0.099-3.11z"
		/>
		<svg:path
			[ngStyle]="{
				'fill': strokeColor
			}"
			d="m10.8 8.99c0.0206 0.00736 0.0412 0.0147 0.0617 0.022 0.156 0.0512 0.315 0.103 0.475 0.154 0.776 0.272 1.57 0.535 2.38 0.738-0.0137 1.03-0.0119 2.06 0.0055 3.09-0.814-0.19-1.61-0.443-2.39-0.711-0.161-0.0502-0.319-0.101-0.475-0.151-0.0206-0.0072-0.0411-0.0145-0.0617-0.0218-0.0036-1.04-0.0039-2.08-0.0011-3.12z"
		/>
		<svg:path
			[ngStyle]="{
				'fill': strokeColor
			}"
			d="m16.8 10.3c1.1-0.0256 2.21-0.286 3.24-0.788-0.0013 0.998-0.0022 2-0.0025 2.99-1.03 0.502-2.13 0.777-3.23 0.824-0.0231-1.01-0.0257-2.02-0.0078-3.03z"
		/>
	</svg:g>

	<!-- flag outline -->
	<svg:path
		[ngStyle]="{
			'stroke': strokeColor
		}"
		class="stroke-width-2 strokeable"
		stroke-linecap="round"
		stroke-linejoin="round"
		d="m4 16c0.309-0.418 0.746-0.744 1.25-0.889 0.519-0.151 1.07-0.131 1.61-0.0483 0.114 0.0176 0.228 0.0376 0.342 0.0595 1.28 0.249 2.5 0.762 3.74 1.19h1e-6c0.16 0.0546 0.32 0.108 0.48 0.161 1.43 0.47 2.89 0.86 4.39 0.929 0.153 7e-3 0.307 0.01 0.46 0.0091 1.67-0.0103 3.34-0.491 4.74-1.41 0.122-3.75 0.122-7.42-2.5e-4 -11-1.36 0.977-3.1 1.37-4.77 1.23-1e-6 -1e-7 -1e-6 -2e-7 -1e-6 -2e-7 -0.154-0.0123-0.307-0.028-0.46-0.0468-1.49-0.184-2.94-0.665-4.36-1.16-0.16-0.0557-0.32-0.113-0.48-0.17-1e-6 -1e-7 -1e-6 -2e-7 -1e-6 -3e-7 -1.24-0.444-2.49-0.907-3.79-1.05-0.116-0.0127-0.232-0.0205-0.349-0.0234h-9e-7c-0.545-0.0132-1.1 0.0817-1.59 0.292-0.473 0.202-0.893 0.509-1.2 0.929"
	/>
	<!-- flagstaff -->
	<svg:path
		[ngStyle]="{
			'stroke': strokeColor
		}"
		class="stroke-width-2 strokeable"
		stroke-linecap="round"
		stroke-linejoin="round"
		d="m4 22v-20"
	/>
</ng-template>

<ng-template #chevronLeftTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable,
			'stroke-width-1': true
		}">
  	<svg:path
			class="stroke-width-1"
			d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
			fill-rule="evenodd"/>
	</svg:g>
</ng-template>

<ng-template #chevronRightTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable,
			'stroke-width-1': true
		}">
  <svg:path
		class="stroke-width-1"
		d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
		fill-rule="evenodd"/>
	</svg:g>
</ng-template>

<ng-template #clearTpl xmlns:svg="http://www.w3.org/2000/svg">
	<!-- circle -->
    <svg:circle
			[ngClass]="{
			'fillable': fillable
		}"
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor,
				'fill': fillColor
			}"
			cx="12"
			cy="12"
			r="11"
		/>

	<!-- the 'x' -->
	<svg:line
		class="strokeable stroke-width-2"
		[ngStyle]="{
			'stroke': strokeColor
		}"
		x1="15"
		x2="9"
		y1="9"
		y2="15"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<svg:line
		class="strokeable stroke-width-2"
		[ngStyle]="{
			'stroke': strokeColor
		}"
		x1="9"
		x2="15"
		y1="9"
		y2="15"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</ng-template>

<ng-template #complainTpl xmlns:svg="http://www.w3.org/2000/svg">
  <svg:g
		stroke-linecap="round"
	>
		<!-- speech balloon -->
		<svg:path
			class="stroke-width-2 strokeable"
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'fill': fillColor,
				'stroke': strokeColor
			}"
			d="m8.209 19.55h-0.542c-4.333 0-6.5-1.083-6.5-6.5v-5.417q0-6.5 6.5-6.5h8.667q6.5 0 6.5 6.5v5.417q0 6.5-6.5 6.5h-0.542a1.1 1.1 0 0 0-0.867 0.433l-1.625 2.167a1.539 1.539 0 0 1-2.6 0l-1.625-2.167a1.2 1.2 0 0 0-0.866-0.433z"
			stroke-linejoin="round"
		/>

		<!-- exclamation mark -->
		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="12"
			x2="12"
			y1="5"
			y2="12"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="12"
			x2="12"
			y1="15.2"
			y2="15.2"
		/>
	</svg:g>
</ng-template>

<ng-template #contactTpl xmlns:svg="http://www.w3.org/2000/svg">
  <svg:g
		stroke-linecap="round"
		stroke-linejoin="round"
	>
		<!-- speech bubble in background -->
		<svg:path
			class="stroke-width-1--point-five strokeable"
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'fill': fillColor,
				'stroke': strokeColor
			}"
			d="m 27.474,17.091 a 3.8,3.8 0 0 0 3.645,-3.966 V 7.76 A 4.167,4.167 0 0 0 26.925,3.766 H 14.101 a 3.812,3.812 0 0 0 -3.78,3.614"
		/>
		<!-- speech bubble in foreground -->
		<svg:path
			class="stroke-width-1--point-five strokeable"
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'fill': fillColor,
				'stroke': strokeColor
			}"
			d="M 20.806,9.951 H 5.142 A 4.112,4.112 0 0 0 1,13.938 v 6.569 a 4.126,4.126 0 0 0 4.142,4 h 1.152 v 3.9 a 0.883,0.883 0 0 0 1.5,0.729 l 4.87,-4.632 h 8.143 a 4.019,4.019 0 0 0 4.02,-4 V 13.935 A 4.006,4.006 0 0 0 20.806,9.951 Z"
		/>
		<!-- upper line -->
		<svg:line
			class="stroke-width-1--point-five strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x2="19.172001"
			x1="6.2940001"
			y1="15.135"
			y2="15.135"
		/>
		<!-- lower line -->
		<svg:line
			class="stroke-width-1--point-five strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x2="19.172001"
			x1="6.2940001"
			y1="19.280001"
			y2="19.280001"
		/>
		</svg:g>
</ng-template>

<ng-template #contractTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
	>
		<svg:path
			class="stroke-width-2 strokeable"
			d="M277.541,879.538a1.008,1.008,0,0,1-1.037.966H256.573a1,1,0,0,1-1.032-.966V853.477a1.009,1.009,0,0,1,1.032-.973H272.3a.783.783,0,0,1,.592.284l4.341,3.947a.762.762,0,0,1,.309.6Z"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-250.541 -850.504)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M271.523,852.5v5h5"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-249.523 -850.504)"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(10 7)"
			x1="6"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(10 11)"
			x1="12"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(10 15)"
			x1="12"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M12-.17A4.687,4.687,0,0,1,9.836-.424c-1.219-.424-3.615-1.44-3.615-1.44-.748-.149-2.09,1.44-2.09,1.44s-.456-.087-1.076-.993-.873-3.192-1.4-2.632A21.788,21.788,0,0,0,0-.17"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(10 25.137)"
		/>
	</svg:g>
</ng-template>

<ng-template #dashboardTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g [ngClass]="{
		'fillable': fillable,
		'strokeable': strokeable
	}">
		<svg:path d="m80.8,20.33l-0.91,0c0.1,10.78 0.31,34.28 0.4,49.76a9.66,9.66 0 0 1 -9.72,9.63l-51.92,0c0,0.64 0,1.27 0,1.92c0,33.87 27.84,61.33 62.19,61.33s62.16,-27.43 62.16,-61.3s-27.85,-61.34 -62.2,-61.34z"/>
		<svg:path d="m70.57,79.75a9.66,9.66 0 0 0 9.72,-9.63c-0.11,-20.65 -0.46,-55.54 -0.46,-55.54a9.65,9.65 0 0 0 -9.72,-9.58l0,0c-35.96,0 -65.11,28.75 -65.11,64.21l0,1a9.65,9.65 0 0 0 9.72,9.58l55.85,-0.04z"/>
	</svg:g>
</ng-template>

<ng-template #datacenterTpl xmlns:svg="http://www.w3.org/2000/svg">

	<!-- Casing -->
	<svg:path
		d="m6.04,2.396h12c1.105,0,2,.895,2,2v17H4.04V4.396c0-1.105.895-2,2-2Z"
		class="strokeable stroke-width-1--point-five"
		[ngClass]="{
			'fillable': fillable
		}"
		[ngStyle]="{
			'fill': fillColor,
			'stroke': strokeColor
		}"
	/>

	<!-- Inner upper line -->
	<svg:path
		class="strokeable stroke-width-1"
		d="m4.227,7.396h15.5"
		[ngStyle]="{
			'stroke': strokeColor
		}"
	/>

	<!-- Inner bottom line -->
	<svg:path
		class="strokeable stroke-width-1"
		d="m4.04,12.396h15.5"
		[ngStyle]="{
			'stroke': strokeColor
		}"
	/>

	<!-- Dot -->
	<svg:path
		class="strokeable stroke-width-1--point-five"
		d="m8.04,15.396h0c.552,0,1,.448,1,1h0c0,.552-.448,1-1,1h0c-.552,0-1-.448-1-1h0c0-.552.448-1,1-1Z"
		[ngStyle]="{
			'fill': strokeColor,
			'stroke': strokeColor
		}"
	/>

	<!-- Base -->
	<svg:path
		class="strokeable stroke-width-1--point-five"
		d="m.979,21.396h22"
		[ngStyle]="{
			'stroke': strokeColor
		}"
	/>
</ng-template>

<ng-template #decommissionTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'strokeable': strokeable
		}"
		stroke-linecap="round"
		stroke-linejoin="round"
	>
		<!-- plug -->
		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="4.452"
			x2="13.43"
			y1="11.58"
			y2="20.56"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'stroke': strokeColor,
				'fill': fillColor
			}"
			d="m3.391 13.64a5.641 5.641 0 1 0 7.978 7.979l1.561-1.561-7.978-7.977z"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="10.33"
			x2="7.328"
			y1="11.46"
			y2="14.46"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="13.53"
			x2="10.53"
			y1="14.66"
			y2="17.66"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="3.336"
			x2="1.039"
			y1="21.67"
			y2="23.98"
		/>

		<!-- socket -->
		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="23.97"
			x2="21.61"
			y1="1.031"
			y2="3.4"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'stroke': strokeColor,
				'fill': fillColor
			}"
			d="m13.75 3.293a5.643 5.643 0 0 1 7.977 7.979l-1.608 1.608-7.977-7.979z"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="14.5"
			x2="16.3"
			y1="7.278"
			y2="5.494"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="17.71"
			x2="19.49"
			y1="10.48"
			y2="8.694"
		/>
	</svg:g></ng-template>

<ng-template #defaultTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g>
		<!-- outer circle	-->
    <svg:circle
			class="strokeable stroke-width-2"
			[ngClass]="{
				'fillable': fillable
			}"
			cx="12"
			cy="12"
			r="11"
			[ngStyle]="{
				'fill': fillColor,
				'stroke': strokeColor
			}"
		/>

		<!-- inner circle	-->
		<svg:circle
			class="fillable strokeable stroke-width-2"
			cx="2"
			cy="2"
			r="2"
			transform="translate(10 10)"
			[ngStyle]="{
				'fill': strokeColor,
				'stroke': strokeColor
			}"
		/>
  </svg:g>
</ng-template>

<ng-template #detailsTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:circle
		class="strokeable stroke-width-1"
		cx="5.5"
		cy="5.5"
		r="5.5"
		transform="translate(4.5 0.5)"
	/>

	<svg:path
		class="strokeable stroke-width-1"
		d="M117.316-2889.024l5.515-5.315"
		stroke-linecap="round"
		stroke-linejoin="round"
		transform="translate(-116.571 2904.547)"
	/>
</ng-template>

<ng-template #documentationTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		stroke-linecap="round"
		stroke-linejoin="round"
	>
		<!-- sheet -->
		<svg:path
			class="stroke-width-1--point-five strokeable"
			[ngClass]="{ 'fillable': fillable }"
			[ngStyle]="{
				'fill': fillColor,
				'stroke': strokeColor
			}"
			d="m 29,9 v 14 c 0,4.2 -2.167,7 -7.222,7 H 10.222 C 5.167,30 3,27.2 3,23 V 9 C 3,4.8 5.167,2 10.222,2 H 21.778 C 26.833,2 29,4.8 29,9 Z"
		/>
		<!-- folded corner -->
    <svg:path
			class="stroke-width-1--point-five strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="M 20.3,2.514 V 8.3 c 0.0033,1.1032 0.8968,1.9967 2,2 h 5.564"
		/>
		<!-- upper line -->
    <svg:path
			class="stroke-width-1--point-five strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m 9,13 h 4"
		/>
		<!-- middle line -->
    <svg:path
			class="stroke-width-1--point-five strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m 9,18 h 8"
		/>
		<!-- lower line -->
    <svg:path
			class="stroke-width-1--point-five strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m 9,23 h 8"
		/>
	</svg:g>
</ng-template>

<ng-template #downloadTpl xmlns:svg="http://www.w3.org/2000/svg">

	<!-- arrow line	-->
	<svg:line
		class="strokeable stroke-width-2"
		fill="none"
		stroke-linecap="round"
		transform="translate(12 0)"
		y2="11.5"
	/>

	<!-- arrow head -->
	<svg:path
		class="strokeable stroke-width-2"
		d="M0,0H5.6V5.6"
		fill="none"
		stroke-linecap="round"
		stroke-linejoin="round"
		transform="translate(15.92 7.96) rotate(135)"
	/>

	<!-- rect	-->
	<svg:path
		class="strokeable stroke-width-2"
		d="M2,0H20a2,2,0,0,1,2,2V7a0,0,0,0,1,0,0H0A0,0,0,0,1,0,7V2A2,2,0,0,1,2,0Z"
		fill="none"
		stroke="#9183b"
		stroke-linejoin="round"
		stroke-width="2"
		transform="translate(1 16)"
	/>

	<!-- dot	-->
	<svg:rect
		class="fillable"
		height="2"
		stroke="none"
		transform="translate(18 18.5)"
		width="2"
	/>
</ng-template>

<ng-template #elsterSubmitTpl xmlns:svg="http://www.w3.org/2000/svg">
	<!-- badge plate fillable background -->
	<svg:circle
		class="stroke-width-0"
		[ngClass]="{
			'fillable': fillable
		}"
		[ngStyle]="{
			'fill': fillColor
		}"
		cx="9.91"
		cy="8.028"
		r="7.034"
	/>

	<!-- arrow + remaining elements of badge -->
	<svg:g
		class="strokeable"
		stroke-linecap="round"
	>
		<!-- arrow shaft -->
		<svg:line
			class="stroke-width-2"
			[ngStyle]="{
	     'stroke': strokeColor
    	}"
			x1="19"
			x2="19"
			y1="11.42"
			y2="1.42"
		/>
		<!-- arrowhead -->
		<svg:path
			class="stroke-width-2"
			[ngStyle]="{
	     'stroke': strokeColor
    	}"
			d="m15.08 4.96 3.96-3.96 3.96 3.96"
			stroke-linejoin="round"
		/>
		<!-- badge plate broken outline -->
		<svg:path
			class="stroke-width-2"
			[ngStyle]="{
	     'stroke': strokeColor
    	}"
			d="m15.18 12.73a7.052 7.041 0 0 1-5.266 2.321 7.301 7.29 0 0 1-7.039-7.028 7.039 7.028 0 0 1 7.039-7.028 6.372 6.362 0 0 1 2.926 0.7258"
		/>
		<!-- ribbon left -->
		<svg:path
			class="stroke-width-2"
			[ngStyle]="{
	     'stroke': strokeColor
    	}"
			d="m9.241 15.01-3.993 7.994-0.8487-3.396-3.4 1.297 4.034-7.737"
			stroke-linejoin="round"
		/>
		<!-- ribbon right -->
		<svg:path
			class="stroke-width-2"
			[ngStyle]="{
	     'stroke': strokeColor
    	}"
			d="m11.12 15.01 3.993 7.994 0.8487-3.4 3.404 1.298-4.034-7.737"
			stroke-linejoin="round"
		/>
	</svg:g>
</ng-template>

<ng-template #errorTpl xmlns:svg="http://www.w3.org/2000/svg">
	<!-- triangular frame/outline/background -->
	<svg:path
		class="triangle fillable strokeable stroke-width-1"
		[ngStyle]="{
			'stroke': strokeColor,
			'fill': fillColor
		}"
		d="m6.64 2.212a1.582 1.581 0 0 1 2.721 0l5.922 9.985a1.582 1.581 0 0 1-1.36 2.387h-11.85a1.582 1.581 0 0 1-1.36-2.387z"
	/>

	<!-- exclamation mark upper -->
	<svg:path
		class="fillable stroke-width-0 exclamation-mark"
		[ngStyle]="{
			'fill': strokeColor
		}"
		d="m8.833 4.231-0.1933 6.42h-1.264l-0.2082-6.42z"
		stroke="none"
	/>

	<!-- exclamation mark lower -->
	<svg:path
		class="fillable stroke-width-0 exclamation-mark"
		[ngStyle]="{
			'fill': strokeColor
		}"
		d="m8.758 13.18h-1.517v-1.568h1.517z"
		stroke="none"
	/>
</ng-template>

<ng-template #ersTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
	>

		<svg:rect
			height="32"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M2,0H26a2,2,0,0,1,2,2V7a0,0,0,0,1,0,0H0A0,0,0,0,1,0,7V2A2,2,0,0,1,2,0Z"
			stroke-linejoin="round"
			transform="translate(2 21)"
		/>

		<svg:rect
			class="stroke-width-2 strokeable"
			height="12.375"
			stroke-linejoin="round"
			transform="translate(7 3)"
			width="18"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linejoin="round"
			transform="translate(16 15.5)"
			y1="5"
		/>

		<svg:rect
			class="strokeable stroke-width-1"
			height="2"
			transform="translate(25 23.5)"
			width="2"
		/>
	</svg:g>
</ng-template>

<ng-template #filterTpl xmlns:svg="http://www.w3.org/2000/svg">

	<svg:g
		stroke-linecap="round"
	>
		<!-- left control -->
		<svg:path
			[ngStyle]="{
			 'stroke': strokeColor
			}"
			class="stroke-width-2 strokeable"
			d="m3 1-1.401e-4 8.5"
		/>

		<svg:path
			[ngStyle]="{
			  'stroke': strokeColor
			}"
			class="stroke-width-2 strokeable"
			d="m3 14.5v8.5"
		/>

		<svg:circle
			[ngClass]="{
			 'fillable': fillable
			}"
			[ngStyle]="{
				'stroke': strokeColor,
				'fill': fillColor
			}"
			class="stroke-width-2 strokeable"
			cx="3"
			cy="12"
			r="2"
		/>

		<!-- middle control -->
		<svg:path
			[ngStyle]="{
				'stroke': strokeColor
			}"
			class="stroke-width-2 strokeable"
			d="m21 1v3.5"
		/>

		<svg:path
			[ngStyle]="{
				'stroke': strokeColor
			}"
			class="stroke-width-2 strokeable"
			d="m21 9.5v13.5"
		/>

		<svg:circle
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'stroke': strokeColor,
			 	'fill': fillColor
			}"
			class="stroke-width-2 strokeable"
			cx="21"
			cy="7"
			r="2"
		/>

		<!-- right control -->
		<svg:path
			[ngStyle]="{
			  'stroke': strokeColor
			}"
			class="stroke-width-2 strokeable"
			d="m12 1v13.53"
		/>

		<svg:path
			[ngStyle]="{
				'stroke': strokeColor
			}"
			class="stroke-width-2 strokeable"
			d="m12 19.5v3.5"
		/>

		<svg:circle
			[ngClass]="{
			 	'fillable': fillable
			}"
			[ngStyle]="{
			  'stroke': strokeColor,
			  'fill': fillColor
			}"
			class="stroke-width-2 strokeable"
			cx="12"
			cy="17"
			r="2"
		/>
	</svg:g>
</ng-template>

<ng-template #importTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g [ngClass]="{
									'fillable': fillable,
									'strokeable': strokeable
								}">
		<svg:line x1="71.91" x2="71.91" y1="49.43" y2="117.78"/>
		<svg:path d="m53.57,68.45l18.36,-19.06l18.35,19"/>
		<svg:path d="m92.28,86.23l23.17,0a26.64,26.64 0 0 0 3.6,-53.16a26.25,26.25 0 0 0 -6.85,0.42a28.66,28.66 0 0 0 -32.47,-19.65a37.38,37.38 0 0 0 -61.21,23.73a25.92,25.92 0 0 0 13.4,48.66l19.61,0"/>
	</svg:g>
</ng-template>

<ng-template #keywordTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		transform="translate(0 0)"
		stroke-linecap="round"
		stroke-linejoin="round"
	>
		<svg:path
			class="stroke-width-1"
			[ngClass]="{
				'fillable': fillable,
				'strokeable': strokeable
			}"
			[ngStyle]="{
				'fill': fillColor,
				'stroke': strokeColor
			}"
			d="M 7.081838607788086 15.49923706054688 C 7.076852798461914 15.49923419952393 7.073875427246094 15.49857616424561 7.072539329528809 15.49817752838135 L 7.071295738220215 15.49780941009521 C 7.058553695678711 15.49216556549072 7.038662433624268 15.48064422607422 7.029282093048096 15.47341346740723 L 0.530109167098999 8.799657821655273 C 0.4916614294052124 8.760306358337402 0.4909602105617523 8.693341255187988 0.5274509191513062 8.654130935668945 L 8.644498825073242 0.8122975826263428 L 8.648319244384766 0.8086075782775879 L 8.652059555053711 0.8048375844955444 C 8.706938743591309 0.749517560005188 8.835248947143555 0.6571375727653503 8.974308967590332 0.5876075625419617 C 9.019818305969238 0.5654671192169189 9.165766716003418 0.5263093709945679 9.297453880310059 0.4999975860118866 L 15.18624401092529 0.4999975860118866 C 15.47231960296631 0.5194298028945923 15.50020885467529 0.7959086298942566 15.50019931793213 0.7987175583839417 L 15.50019931793213 6.74872350692749 C 15.47393894195557 6.871242523193359 15.43344116210938 7.0234375 15.40801906585693 7.078867435455322 C 15.38576030731201 7.127399444580078 15.29001140594482 7.259416580200195 15.20292186737061 7.362256526947021 C 15.1667947769165 7.398680210113525 15.07023239135742 7.496243476867676 14.92439937591553 7.643577575683594 C 8.869409561157227 13.76136112213135 7.382541179656982 15.22347640991211 7.081937313079834 15.49923706054688 C 7.081904411315918 15.49923706054688 7.081871509552002 15.49923706054688 7.081838607788086 15.49923706054688 Z M 11.99980926513672 2.499697685241699 C 11.59841918945312 2.499697685241699 11.22148895263672 2.656657695770264 10.93842887878418 2.941657543182373 C 10.35571956634521 3.527057647705078 10.35571956634521 4.480237483978271 10.93882942199707 5.066037654876709 C 11.22226905822754 5.350777626037598 11.59902954101562 5.50759744644165 11.99969959259033 5.50759744644165 C 12.40094947814941 5.50759744644165 12.7780294418335 5.350777626037598 13.0614595413208 5.066037654876709 C 13.64457893371582 4.480237483978271 13.64457893371582 3.527057647705078 13.06146907806396 2.941257476806641 C 12.7780294418335 2.656517505645752 12.4009895324707 2.499697685241699 11.99980926513672 2.499697685241699 Z"
		/>
	</svg:g>
</ng-template>

<ng-template #licencesTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g [ngClass]="{
									'fillable': fillable,
									'strokeable': strokeable
								}">
		<svg:path d="m74.79,132.58l69.78,-86.44l-26.78,-41.14l-85.93,0l-26.84,41.14l69.77,86.44z"/>
		<svg:line x1="5" x2="144.56" y1="46.14" y2="46.14"/>
		<svg:path d="m74.79,5l-24.9,41.14l24.9,86.44"/>
		<svg:path d="m74.79,5l24.88,41.14l-24.88,86.44"/>
		<svg:line x1="99.66" x2="117.72" y1="46.14" y2="5"/>
		<svg:line x1="49.89" x2="31.84" y1="46.14" y2="5"/>
	</svg:g>
</ng-template>

<ng-template #lockedTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g [ngClass]="{ 'fillable': fillable }" transform="translate(284.000000, 430.000000)">
			<svg:path class="fillable"
								d="M-237.7-401.3h-3v-6.4c0-6.2-5.1-11.3-11.3-11.3c-6.2,0-11.3,5.1-11.3,11.3v6.4h-3v-6.4     c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3V-401.3"/>
			<svg:path class="fillable"
								d="M-239.2-374.1h-25.6c-2.6,0-4.8-2.2-4.8-4.8v-19.2c0-2.6,2.2-4.8,4.8-4.8h25.6     c2.6,0,4.8,2.2,4.8,4.8v19.2C-234.4-376.2-236.6-374.1-239.2-374.1L-239.2-374.1z M-264.8-399.7c-0.9,0-1.6,0.7-1.6,1.6v19.2     c0,0.9,0.7,1.6,1.6,1.6h25.6c0.9,0,1.6-0.7,1.6-1.6v-19.2c0-0.9-0.7-1.6-1.6-1.6H-264.8L-264.8-399.7z"/>
			<svg:path class="fillable" d="M-248.8-393.3c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2S-248.8-395-248.8-393.3     "/>
			<svg:polyline class="fillable" points="-251.2,-393.3 -252.8,-393.3 -254.4,-383.7 -249.6,-383.7 -251.2,-393.3    "/>
	</svg:g>
</ng-template>

<ng-template #magnifierTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
	>

		<!-- handle -->
		<svg:path
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m1.16 22.9 8.002-8.002"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>

		<!-- glass -->
    <svg:circle
			class="strokeable fillable stroke-width-2"
			[ngStyle]="{
				'fill': fillColor,
				'stroke': strokeColor
			}"
			cx="14.9"
			cy="9.09"
			r="8.022"
		/>
  </svg:g>
</ng-template>

<ng-template #manageTenantTpl xmlns:svg="http://www.w3.org/2000/svg">
 <svg:g>

		<!-- building -->
		<svg:path
			class="strokeable stroke-width-1"
			d="M537.428,1197.668v-4.747l9-1.637v15h-9v-1.566"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-530.928 -1190.784)"
		/>

		<!-- upper window line -->
		<svg:path
			class="strokeable stroke-width-1"
			d="M0,.021H2.9V0H0Z"
			stroke-linejoin="round"
			transform="translate(9.553 4.599)"
		/>

		<!-- lower window line -->
		<svg:path
			class="strokeable stroke-width-1"
			d="M0,.021H2.9V0H0Z"
			stroke-linejoin="round"
			transform="translate(9.553 6.805)"
		/>

		<!-- door -->
		 <svg:path
			 class="strokeable stroke-width-1"
			 d="M0,0H2.757V5H0Z"
			 stroke-linejoin="round"
			 transform="translate(9.553 10.5)"
		 />

		<!-- arrow line -->
		<svg:line
			class="strokeable stroke-width-1"
			stroke-linecap="round"
			transform="translate(0.5 10.526)"
			x2="5.167"
		/>

		<!-- arrow tip -->
		<svg:path
			class="strokeable stroke-width-1"
			d="M0,3.733H3.733V0"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(0.72 10.5) rotate(-45)"
		/>
  </svg:g>
</ng-template>

<ng-template #manifestTpl xmlns:svg="http://www.w3.org/2000/svg">

		<!-- bracket left	-->
    <svg:path
			class="strokeable stroke-width-2"
			d="M.313.545A2.17,2.17,0,0,0-1.45,1.754c-.229.67-.147,1.943-.2,4.638.114,2.368-2.809,2.89-2.809,2.89A4.847,4.847,0,0,1-1.858,11c.615,1.215-.127,3.89.408,5.813.284,1.016,1.894,1.208,1.894,1.208"
			transform="translate(5.5 3)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<!-- dot upper -->
		<svg:path
			class="fillable strokeable stroke-width-2"
			d="M267.442,404.439a1.209,1.209,0,0,1-1.2,1.242,1.237,1.237,0,0,1-1.249-1.207,1.215,1.215,0,0,1,1.213-1.236A1.2,1.2,0,0,1,267.442,404.439Z"
			transform="translate(-254.564 -394.457)"
			[ngStyle]="{
				'fill': strokeColor,
				'stroke': strokeColor
			}"
		/>
		<!-- dot lower -->
    <svg:path
			class="fillable strokeable stroke-width-2"
			d="M267.442,404.439a1.209,1.209,0,0,1-1.2,1.242,1.237,1.237,0,0,1-1.249-1.207,1.215,1.215,0,0,1,1.213-1.236A1.2,1.2,0,0,1,267.442,404.439Z"
			transform="translate(-254.564 -389.457)"
			[ngStyle]="{
				'fill': strokeColor,
				'stroke': strokeColor
			}"
		/>

		<!-- bracket right -->
    <svg:path
			class="strokeable stroke-width-2"
			d="M-4.325.545A2.17,2.17,0,0,1-2.561,1.754c.229.67.147,1.943.2,4.638C-2.479,8.759.444,9.282.444,9.282A4.847,4.847,0,0,0-2.153,11c-.615,1.215.127,3.89-.408,5.813-.284,1.016-1.894,1.208-1.894,1.208"
			transform="translate(21.5 3)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>
</ng-template>

<ng-template #manifestAssignTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g transform="translate(0 0.04)">

		<!-- bracket left -->
    <svg:path
			class="strokeable stroke-width-2"
			d="M.313.545A2.17,2.17,0,0,0-1.45,1.754c-.229.67-.147,1.943-.2,4.638.114,2.368-2.809,2.89-2.809,2.89A4.847,4.847,0,0,1-1.858,11c.42.83.207,1.341.2,3.144"
			transform="translate(5.5 0.455)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<!-- dot upper -->
		<svg:path
			class="fillable strokeable stroke-width-2"
			d="M267.489,404.467a1.235,1.235,0,0,1-1.227,1.271,1.263,1.263,0,0,1-1.273-1.235,1.24,1.24,0,0,1,1.236-1.265A1.22,1.22,0,0,1,267.489,404.467Z"
			transform="translate(-254.239 -397.457)"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<!-- dot lower -->
    <svg:path
			class="fillable strokeable stroke-width-2"
			d="M267.489,404.467a1.235,1.235,0,0,1-1.227,1.271,1.263,1.263,0,0,1-1.273-1.235,1.24,1.24,0,0,1,1.236-1.265A1.22,1.22,0,0,1,267.489,404.467Z"
			transform="translate(-254.239 -392.457)"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<!-- bracket right -->
    <svg:path
			class="strokeable stroke-width-2"
			d="M-4.325.545A2.17,2.17,0,0,1-2.561,1.754c.229.67.147,1.943.2,4.638C-2.479,8.759.444,9.282.444,9.282A4.847,4.847,0,0,0-2.153,11c-.615,1.215.127,3.89-.408,5.813-.284,1.016-1.894,1.208-1.894,1.208"
			transform="translate(22.5 0.455)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<!-- arrow -->
    <svg:g transform="translate(3 7)">

			<!-- line -->
      <svg:path
				class="strokeable stroke-width-2"
				d="M54.143,2.272v-8"
				transform="translate(3.272 -42.143) rotate(90)"
				stroke-linecap="round"
				stroke-linejoin="round"
				[ngStyle]="{
					'stroke': strokeColor
				}"
			/>

			<!-- head -->
      <svg:path
				class="strokeable stroke-width-2"
				d="M0,8,4,4,0,0"
				transform="translate(5.512 8)"
				stroke-linecap="round"
				stroke-linejoin="round"
				[ngStyle]="{
					'stroke': strokeColor
				}"
			/>
    </svg:g>
  </svg:g>
</ng-template>

<ng-template #manualExportTpl xmlns:svg="http://www.w3.org/2000/svg">
  <svg:g class="strokeable" transform="translate(20 30.146) rotate(180)">
    <svg:path class="strokeable stroke-width-3" d="M0,0V11.646" transform="translate(4 2.083)"/>
    <svg:path class="strokeable stroke-width-3" d="M0,2.274,3.974-1.749,8,2.274" transform="translate(0 1.749)"/>
  </svg:g>
  <svg:path
		class="strokeable stroke-width-3"
		d="M392.031,1175.027s4.146-.032,4.175,0c7.72.034,9.013-9.5,2.093-11.523.518-2.893-.973-5.027-3.374-6.312-2.87-1.551-7.395-1.109-8.978,2.184a6.14,6.14,0,0,0-5.48.641,4.918,4.918,0,0,0-2.364,4.722s-5.292.344-5.287,5.432c.09,2.714,2.489,4.7,5.54,4.856l8.5,0"
		transform="translate(-371.815 -1154.327)"/>
</ng-template>

<ng-template #messageTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g class="strokeable">
		<!-- letter envelope body -->
		<svg:rect
			class="stroke-width-1--point-five"
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'fill': fillColor,
				'stroke': strokeColor
			}"
			x="2"
			y="4"
			width="20"
			height="16"
			rx="3"
		/>
		<!-- letter envelope flap -->
		<svg:path
			class="stroke-width-1--point-five"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="M3 5.5L9.5 12C9.5 12 10.5 13 12 13C13.5 13 14.5 12 14.5 12L21 5.5"
			stroke-linecap="round"
		/>
	</svg:g>
</ng-template>

<ng-template #myAccountTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'strokeable': strokeable
		}"
	>
		<svg:path
			class="stroke-width-2 strokeable"
			d="M567.005,1218.784s-.7-6.59-6.409-6.578-6.595,6.578-6.595,6.578H537.428v-25.1l16.516-2.39L554,1210"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-535.928 -1189.284)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M0,0H5V9H0Z"
			stroke-linejoin="round"
			transform="translate(7.245 20.5)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M0,.037H5.25V0H0Z"
			stroke-linejoin="round"
			transform="translate(7.358 9.265)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M0,.037H5.25V0H0Z"
			stroke-linejoin="round"
			transform="translate(7.358 13.265)"
		/>

		<svg:circle
			class="stroke-width-2 strokeable"
			cx="3"
			cy="3"
			r="3"
			stroke-linejoin="round"
			transform="translate(22 14)"
		/>
	</svg:g>
</ng-template>

<ng-template #noAssignmentTpl xmlns:svg="http://www.w3.org/2000/svg">
  <svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
	>
		<svg:rect class="fillable" opacity="0"/>

		<svg:circle
			class="stroke-width-1 strokeable"
			cx="7"
			cy="7"
			fill="none"
			r="7"
			transform="translate(1 1)"
		/>

		<svg:path
			class="stroke-width-1 strokeable"
			d="M.954.215l9.921,10.037"
			fill="none"
			transform="translate(2 3)"
		/>
  </svg:g>
</ng-template>

<ng-template #noIconTpl xmlns:svg="http://www.w3.org/2000/svg">
  <svg:g>
		<svg:circle
			class="stroke-width-1 strokeable"
			[ngClass]="{
				'fillable': fillable
			}"
			[ngStyle]="{
				'fill':fillColor,
				'stroke': strokeColor
			}"
			cx="12"
			cy="12"
			r="11.5"
		></svg:circle>

		<!-- I -->
		<svg:path
			class="fillable stroke-width-0"
			[ngStyle]="{
				'fill':strokeColor
			}"
			d="m5.661 14.96h-2.911v-1.041h0.8146v-3.789h-0.8146v-1.041h2.911v1.041h-0.8146v3.789h0.8146z"
		/>
		<!-- C -->
    <svg:path
			[ngStyle]="{
				'fill':strokeColor
			}"
			class="fillable stroke-width-0"
			d="m8.626 15.11q-0.5542 0-1.025-0.1932-0.4673-0.1932-0.8045-0.5756t-0.5241-0.9541q-0.1836-0.5717-0.1836-1.321 0-0.6979 0.1769-1.266 0.1769-0.5681 0.5141-0.9739 0.3238-0.3903 0.8012-0.6032 0.4807-0.2129 1.048-0.2129 0.3138 0 0.5642 0.04337 0.2537 0.03943 0.4673 0.1065 0.2237 0.07491 0.4039 0.1695 0.1836 0.09068 0.3205 0.1695v1.423h-0.1469q-0.09347-0.09463-0.2371-0.2247-0.1402-0.1301-0.3205-0.2563-0.1836-0.1262-0.3972-0.2129-0.2136-0.0867-0.4574-0.08674-0.2704 0-0.5141 0.1025-0.2437 0.09857-0.4507 0.3312-0.1969 0.2247-0.3205 0.5954-0.1202 0.3706-0.1202 0.8989 0 0.552 0.1302 0.9226 0.1336 0.3706 0.3339 0.5835 0.2036 0.2168 0.454 0.3115 0.2504 0.09068 0.494 0.09068 0.2337 0 0.4607-0.0828 0.2304-0.0828 0.424-0.2247 0.1635-0.1143 0.3038-0.2444 0.1402-0.1301 0.2304-0.2247h0.1336v1.404q-0.187 0.09857-0.3572 0.1853-0.1702 0.08674-0.3572 0.1498-0.2437 0.0828-0.4574 0.1262-0.2136 0.04337-0.5876 0.04337z"
		/>
		<!-- O -->
    <svg:path
			[ngStyle]="{
				'fill':strokeColor
			}"
			class="fillable stroke-width-0"
			d="m16.12 12.06q0 1.404-0.681 2.232-0.681 0.824-1.883 0.824-1.198 0-1.88-0.824-0.681-0.828-0.681-2.232 0-1.415 0.681-2.236 0.681-0.824 1.88-0.824 1.195 0 1.88 0.824 0.6844 0.8201 0.6844 2.236zm-1.699 1.486q0.187-0.2681 0.2771-0.6308 0.09013-0.3667 0.09013-0.8595 0-0.5283-0.1035-0.8989t-0.2704-0.5993q-0.1702-0.2366-0.3939-0.343-0.2203-0.1065-0.4607-0.1065-0.2437 0-0.4607 0.1025-0.2136 0.1025-0.3939 0.3391-0.1669 0.2208-0.2737 0.6111-0.1035 0.3864-0.1035 0.8989 0 0.5244 0.1001 0.895 0.1035 0.3667 0.2704 0.5993t0.3905 0.343q0.2237 0.1104 0.4707 0.1104t0.4707-0.1104q0.2237-0.1143 0.3905-0.3509z"
		/>
		<!-- N -->
    <svg:path
			[ngStyle]="{
				'fill':strokeColor
			}"
			class="fillable stroke-width-0"
			d="m21.25 14.99h-1.235l-2.11-4.029v4.029h-1.175v-5.871h1.532l1.813 3.363v-3.363h1.175z"
		/>
	</svg:g>
</ng-template>

<ng-template #notificationBellTpl xmlns:svg="http://www.w3.org/2000/svg">
  <svg:g
		[ngClass]="
		{
			'fillable': fillable,
			'strokeable': strokeable
		}"
		transform="translate(-0.833 -7.965)"
	>
    <svg:path
			class="stroke-width-1--point-five"
			d="M17.425,18.035c-.044.043-16.887-.015-16.962,0A.818.818,0,0,1-.1,16.882l2.778-4.4V6.312a6.27,6.27,0,1,1,12.539,0v6.172l2.685,4.4A.766.766,0,0,1,17.425,18.035Z"
			transform="translate(2.013 8.965)"
		/>

    <svg:path
			class="stroke-width-1--point-five"
			d="M0,0S.128,3.6,3.425,3.57,7,0,7,0"
			transform="translate(7.5 27)"
		/>
  </svg:g>
</ng-template>

<ng-template #organizationsTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
	>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M-.245,3.709s-.019-.9,0-.928a2.385,2.385,0,0,1,1.53-1.7L12.278-2.438,23.153,1.083a2.488,2.488,0,0,1,1.6,1.973,3.718,3.718,0,0,0,0,.554"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(3.745 18.729)"
		/>

		<svg:rect
			class="stroke-width-2 strokeable"
			height="10"
			rx="1"
			stroke-linejoin="round"
			transform="translate(11 1.2)"
			width="10"
		/>

		<svg:g
			class="stroke-width-2 strokeable"
			stroke-linejoin="round"
			transform="translate(2 27)"
		>

			<svg:rect
				class="stroke-width-0"
				height="3"
				rx="0.5"
				width="3"
			/>

			<svg:rect
				class="stroke-width-2 strokeable"
				height="5"
				rx="1.5"
				width="5"
				x="-1"
				y="-1"
			/>
		</svg:g>

		<svg:g
			class="stroke-width-2 strokeable"
			stroke-linejoin="round"
			stroke-width="2"
			transform="translate(27 27)"
		>

			<svg:rect
				class="stroke-width-0"
				height="3"
				rx="0.5"
				stroke="none"
				width="3"
			/>

			<svg:rect
				class="stroke-width-2 strokeable"
				height="5"
				rx="1.5"
				width="5"
				x="-1"
				y="-1"
			/>
		</svg:g>

		<svg:g
			class="stroke-width-2 strokeable"
			stroke-linejoin="round"
			transform="translate(14.5 27)"
		>

			<svg:rect
				class="stroke-width-0"
				height="3"
				rx="0.5"
				width="3"
			/>

			<svg:rect
				class="stroke-width-2 strokeable"
				height="5"
				rx="1.5"
				width="5"
				x="-1"
				y="-1"
			/>
		</svg:g>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M0-1V10.162"
			fill="none"
			stroke="#d1d4db"
			stroke-linecap="round"
			stroke-width="2"
			transform="translate(16 12.2)"
		/>
	</svg:g>
</ng-template>

<ng-template #patchTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g transform="translate(1 1)">
		<svg:g
			transform="translate(-0.5 -0.5)"
			stroke-linecap="round"
			stroke-linejoin="round"
		>

			<!-- outer shape -->
			<svg:path
				class="strokeable stroke-width-2"
				[ngClass]="{
					'fillable': fillable
				}"
				d="M9.7,22.923A5.387,5.387,0,0,1,2.077,15.3L15.3,2.078A5.386,5.386,0,1,1,22.922,9.7Z"
				[ngStyle]="{
					'fill': fillColor,
					'stroke': strokeColor
				}"
			/>
		</svg:g>

		<!-- upper right line -->
		<svg:line
			class="strokeable stroke-width-2"
			x2="6.705"
			y2="6.705"
			transform="translate(12.572 4.61)"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<!-- lower left line -->
		<svg:line
			class="strokeable stroke-width-2"
			x1="5.867"
			y1="5.867"
			transform="translate(5.029 12.991)"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<!-- Dots -->
		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(8.741 10.914)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(10.914 10.913)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(10.914 8.741)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(13.098 10.913)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(13.098 8.741)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(15.28 10.913)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(15.28 13.097)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(13.098 13.097)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(13.098 15.28)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(10.914 13.097)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(10.914 15.28)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="strokeable stroke-width-1--point-five"
			transform="translate(8.73 13.097)"
			stroke-linecap="round"
			stroke-linejoin="round"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>
	</svg:g>
</ng-template>

<!-- Reactivate SVG is not correctly prepared, that is why we need to use stroke-width-1 (width: 1px) -->
<ng-template #reactivateTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g transform="translate(0 0.003)">
		<svg:rect class="fillable" opacity="0"/>
		<svg:path class="strokeable stroke-width-1"
							d="M8679.44,4784.513v15l9.289-7.433Z"
							fill="none" stroke-linejoin="round"
							transform="translate(-8674.842 -4784.016)"
		/>
	</svg:g>
</ng-template>

<ng-template #reloadTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		stroke-linecap="round"
	>
		<!-- open circle -->
		<svg:path
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m22 12a10 10 0 1 1-20 0c-0.02-5.123 4.4-10.14 10-10s7.741 3.8 7.741 3.8"
		/>

		<!-- arrowhead -->
		<svg:path
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m21.33 3.002v4.229h-4.331"
		/>

	</svg:g>
</ng-template>

<ng-template #resetTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g class="fillable" transform="translate(-1.999 -0.816)">
		<svg:path
			d="M2.451,13.791a10,10,0,1,1,17.218,3.418L18.007,16.07A7.984,7.984,0,1,0,13.4,18.686l-.818-2.636,4.671,2.466-2.456,4.668-.8-2.569A10,10,0,0,1,2.451,13.791"/>
		<svg:path d="M16.035,8.342,14.658,6.965,12,9.623,9.342,6.965,7.965,8.342,10.623,11,7.965,13.658l1.377,1.377L12,12.378l2.658,2.657,1.377-1.377L13.377,11Z"/>
	</svg:g>
</ng-template>

<ng-template #returnTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		stroke-linecap="round"
		stroke-linejoin="round"
	>
		<!-- box -->
		<svg:g
			[ngClass]="{
				'fillable': fillable
			}"
		>
			<svg:path
				class="stroke-width-2 strokeable"
				[ngStyle]="{
					'stroke': strokeColor,
					'fill': fillColor
				}"
				d="m23.98 18.48-11.17 5.488v-11.79l11.17-5.488z"
			/>

			<svg:path
				class="stroke-width-2 strokeable"
				[ngStyle]="{
					'stroke': strokeColor,
					'fill': fillColor
				}"
				d="m12.81 23.98-11.78-5.488v-11.79l11.78 5.488z"
			/>

			<svg:path
				class="stroke-width-2 strokeable"
				[ngStyle]="{
					'stroke': strokeColor,
					'fill': fillColor
				}"
				d="m13.03 1.025-12.01 5.671 11.78 5.489 11.17-5.489z"
			/>
		</svg:g>

		<!-- "slit" on top -->
		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="6.914"
			x2="18.39"
			y1="3.913"
			y2="9.44"
		/>

		<!-- "label" -->
		<svg:line
			class="stroke-width-2 strokeable"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			x1="3.265"
			x2="5.911"
			y1="13.85"
			y2="15.12"
		/>
	</svg:g>
</ng-template>

<ng-template #revertTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'strokeable': strokeable
		}"
	>
		<!-- u-turn line -->
    <svg:path
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m5.25 18.73h11.88a5.583 5.583 0 0 0 5.7-5.456 5.584 5.584 0 0 0-5.7-5.457h-14.7"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>

		<!-- arrowhead -->
    <svg:path
			class="strokeable stroke-width-2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
			d="m6.028 3.619-4.8 4.2 4.8 4.2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg:g>
</ng-template>

<ng-template #signaturesTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="
		{
			'strokeable': strokeable
		}"
		transform="translate(-1217 -843.999)"
	>

		<!-- front rec	-->
		<svg:rect
			class="stroke-width-2 strokeable"
			height="12"
			stroke-linejoin="round"
			transform="translate(1218 854.999)"
			width="12"
		/>

		<!-- mid rec	-->
		<svg:path
			class="stroke-width-2 strokeable"
			d="M1222.425,854.971v-5.493h12v12h-4.514"
			stroke-linejoin="round"
			transform="translate(0.575 0.521)"
		/>

		<!-- back rec	-->
		<svg:path
			class="stroke-width-2 strokeable"
			d="M1222.425,854.971v-5.493h12v12h-4.514"
			stroke-linejoin="round"
			transform="translate(5.575 -4.479)"
		/>
	</svg:g>
</ng-template>

<ng-template #signaturePackageTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="
		{
			'strokeable': strokeable
		}"
		transform="translate(-1217 -843.999)"
	>

		<!-- front rec	-->
		<svg:rect
			class="stroke-width-2 strokeable"
			height="12"
			stroke-linejoin="round"
			transform="translate(1218 854.999)"
			width="12"
		/>

		<!-- mid rec	-->
		<svg:path
			class="stroke-width-2 strokeable"
			d="M1222.425,854.971v-5.493h12v12h-4.514"
			stroke-linejoin="round"
			transform="translate(0.575 0.521)"
		/>

		<!-- back rec	-->
		<svg:path
			class="stroke-width-2 strokeable"
			d="M1222.425,854.971v-5.493h12v12h-4.514"
			stroke-linejoin="round"
			transform="translate(5.575 -4.479)"
		/>

		<!-- horizontal plus line	-->
		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			transform="translate(1221 860.999)"
			x2="6"
		/>

		<!-- vertical plus line	-->
    <svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			transform="translate(1224 857.999)"
			y1="6"
		/>
	</svg:g>
</ng-template>

<ng-template #starTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:path
		class="stroke-width-2 strokeable"
		[ngClass]="{ 'fillable': fillable }"
		[ngStyle]="{
			'fill': fillColor,
			'stroke': strokeColor
		}"
		d="M11.0489 2.92705C11.3483 2.00574 12.6517 2.00574 12.9511 2.92705L14.4697 7.60081C14.6035 8.01284 14.9875 8.2918 15.4207 8.2918H20.335C21.3037 8.2918 21.7065 9.53141 20.9228 10.1008L16.947 12.9894C16.5966 13.244 16.4499 13.6954 16.5838 14.1074L18.1024 18.7812C18.4017 19.7025 17.3472 20.4686 16.5635 19.8992L12.5878 17.0106C12.2373 16.756 11.7627 16.756 11.4122 17.0106L7.43648 19.8992C6.65276 20.4686 5.59828 19.7025 5.89763 18.7812L7.41623 14.1074C7.55011 13.6954 7.40345 13.244 7.05296 12.9894L3.07722 10.1008C2.29351 9.53141 2.69628 8.2918 3.66501 8.2918H8.57929C9.01252 8.2918 9.39647 8.01284 9.53035 7.60081L11.0489 2.92705Z"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</ng-template>

<ng-template #statusTpl xmlns:svg="http://www.w3.org/2000/svg">
  <svg:g
		stroke-linecap="round"
		stroke-linejoin="round"
	>
		<!-- frame/screen -->
    <svg:path
			class="stroke-width-1--point-five strokeable"
			[ngClass]="{ 'fillable': fillable }"
			[ngStyle]="{
			'fill': fillColor,
			'stroke': strokeColor
			}"
			d="M 11.77 30 L 20.17 30 C 27.17 30 29.97 27.2 29.97 20.2 L 29.97 11.8 C 29.97 4.8 27.17 2 20.17 2 L 11.77 2 C 4.77 2 1.97 4.8 1.97 11.8 L 1.97 20.2 C 1.97 27.2 4.77 30 11.77 30 Z"
		/>
		<!-- zigzag graph -->
    <svg:path
			class="stroke-width-1--point-five strokeable"
			[ngStyle]="{
			'stroke': strokeColor
			}"
			d="M 1.97 17.604 L 6.055 17.59 L 7.98 13.59 L 9.598 17.59 L 12.37 17.584 C 13.3946 17.5687 14.3658 18.0398 14.988 18.854 L 16.588 21.734 C 16.952 22.384 17.526 22.384 17.888 21.734 L 21.094 12.924 C 21.1976 12.6696 21.4404 12.4992 21.7149 12.4885 C 21.9894 12.4777 22.2448 12.6285 22.368 12.874 L 23.824 17.844 C 24.4688 18.5247 25.3644 18.9114 26.302 18.914 L 29.98 18.914"
		/>
  </svg:g>
</ng-template>

<ng-template #structureTpl xmlns:svg="http://www.w3.org/2000/svg">

	<svg:g
		[ngClass]="
		{
			'fillable': fillable,
			'strokeable': strokeable
		}"
		transform="translate(2)"
	>
	<svg:path
		class="stroke-width-2 strokeable"
		d="M1533.2,912.054a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,1533.2,912.054Z"
		stroke-linecap="round"
		stroke-linejoin="round"
		transform="translate(-1507.699 -883.054)"
	/>

  <svg:path
		class="stroke-width-2 strokeable"
		d="M-1.105-1.623,3.912,4.236"
		stroke-linecap="round"
		transform="translate(19.782 20.123)"
	/>

		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(3.271 11.963)"
			x1="6.23"
			y1="0.537"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M1518.325,912.232a1.866,1.866,0,1,1,1.866-1.866A1.866,1.866,0,0,1,1518.325,912.232Z"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-1511.817 -881.575)"
		/>
		<svg:path
			class="stroke-width-2 strokeable"
			d="M1521.009,893.983a2,2,0,1,1,2-2A2,2,0,0,1,1521.009,893.983Z"
			transform="translate(-1512.011 -888.983)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M1515.01,899.983a2,2,0,1,1,2-2A2,2,0,0,1,1515.01,899.983Z"
			transform="translate(-1513.011 -885.983)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M1534.851,895.406a2,2,0,1,1,2-2A2,2,0,0,1,1534.851,895.406Z"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-1507.851 -886.406)"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(7.442 27.183)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M-1.145,8.557l5-8.718"
			stroke-linecap="round"
			transform="translate(8.803 18.5)"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(9.5 3.5)"
			x2="3"
			y2="5"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M1531.46,899.937a5.577,5.577,0,1,1-5.577-5.578A5.577,5.577,0,0,1,1531.46,899.937Z"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-1510.486 -886.469)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M0,3,4.612.809"
			stroke-linecap="round"
			transform="translate(20.5 7.5)"
		/>
  </svg:g>
</ng-template>

<!-- Suspended SVG is not correctly prepared, that is why we need to use stroke-width-1 (width: 1px) -->
<ng-template #suspendedTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g>
		<svg:rect
			class="fillable" opacity="0"/>
		<svg:rect
			class="strokeable stroke-width-1" fill="none" height="15" stroke-linejoin="round" transform="translate(1.5 0.5)" width="4"/>
		<svg:rect
			class="strokeable stroke-width-1" fill="none" height="15" stroke-linejoin="round" transform="translate(10.5 0.5)" width="4"/>
	</svg:g>
</ng-template>

<ng-template #tenantsTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
	>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M537.428,1193.664l16.574-2.38v27.5H537.428Z"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-534.928 -1189.284)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M569.369,1209.942l9.824,2.043v15.86h-9.824Z"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(-550.296 -1198.343)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M0,0H5V9H0Z"
			stroke-linejoin="round"
			transform="translate(8.245 20.5)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M0,.037H5.25V0H0Z"
			stroke-linejoin="round"
			transform="translate(8.358 9.265)"
		/>

		<svg:path
			class="stroke-width-2 strokeable"
			d="M0,.037H5.25V0H0Z"
			stroke-linejoin="round"
			transform="translate(8.358 13.265)"
		/>
	</svg:g>
</ng-template>

<ng-template #transactionsTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g [ngClass]="{
									'fillable': fillable,
									'strokeable': strokeable
								}">
		<svg:path d="M121.727 25.516v115.863" stroke-linejoin="miter"/>
		<svg:path d="M101.219 35.46l20.375-20.624 20.625 20.625" stroke-linejoin="round"/>
		<svg:path d="M84.227 90.64v50.239M9.227 116.04v24.843" stroke-linejoin="miter"/>
		<svg:path d="M83.57 55.645a169.737 169.737 0 0 1-35 21.972A180.769 180.769 0 0 1 5.34 90.648" stroke-linejoin="round"/>
		<svg:path d="M46.727 107.797v33.086" stroke-linejoin="miter"/>
	</svg:g>
</ng-template>

<ng-template #tssTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g [ngClass]="{
									'fillable': fillable,
									'strokeable': strokeable
								}">
		<svg:path d="M131.2,43.6c0,20.6-16.7,37.2-37.2,37.2c-9.5,0-18.2-3.6-24.8-9.5c-7.6-6.8-12.4-16.7-12.4-27.7
							C56.8,23.1,73.4,6.4,94,6.4S131.2,23.1,131.2,43.6z"/>
		<svg:polyline class="fillable-null" points="69.2,71.4 37.3,105.1 18.9,124.6 37.8,143.5 "/>
		<svg:line class="fillable-null" x1="57.5" x2="37.3" y1="124.5" y2="105.1"/>
	</svg:g>
</ng-template>

<ng-template #tssModeCloudTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
		transform="translate(0.014)"
	>

		<!-- Cloud -->
    <svg:path
			class="stroke-width-2 fillable strokeable"
			d="M378.035,1172.623a5.7,5.7,0,1,1,.694-11.286c-.46-3.853,4.128-5.638,7.207-3.369,1.083-2.786,5.34-3.791,8.743-2.284,2.786,1.51,3.15,3.29,3.328,6.849,6.809,2.321,3.372,10.09-2.095,10.09Z"
			fill="none"
			stroke-linecap="round"
			transform="translate(-370.963 -1148.881)"
			[ngStyle]="{
				'fill': fillable ? fillColor : 'transparent',
				'stroke': strokeColor
			}"
		/>
	</svg:g>
</ng-template>

<ng-template #tssModeOfflineTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
				'fill': fillable ? fillColor : 'transparent',
			'strokeable': strokeable
		}"
		transform="translate(0.014)"
	>

		<!-- Cloud -->
		<svg:path
			class="stroke-width-2 fillable strokeable"
			d="M378.069,1172.623a5.705,5.705,0,1,1,.7-11.286c-.463-3.853,4.15-5.638,7.246-3.369,1.089-2.786,5.369-3.791,8.79-2.284,2.8,1.51,3.167,3.29,3.346,6.849,6.846,2.321,3.39,10.09-2.106,10.09Z"
			fill="none"
			stroke-linecap="round"
			transform="translate(-370.963 -1148.881)"
			[ngStyle]="{
				'fill': fillable ? fillColor : 'transparent',
				'stroke': strokeColor
			}"
		/>

		<!-- Line -->
		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(2.5 3.5)"
			x2="26"
			y1="25"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>
  </svg:g>
</ng-template>

<ng-template #tssModeTokenTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="{
			'fillable': fillable,
			'strokeable': strokeable
		}"
	>

	  <!-- outer rect -->
		<svg:rect
			class="stroke-width-2 fillable strokeable"
			fill="none"
			height="21.333"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(5.333 5.333)"
			width="21.333"
			[ngStyle]="{
				'fill': fillable ? fillColor : 'transparent',
				'stroke': strokeColor
			}"
		/>


		<svg:line
			class="stroke-width-2 strokeable"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(9.599 2.133)"
			y2="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(13.867 2.133)"
			y2="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>
		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(18.133 2.133)"
			y2="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(22.4 2.133)"
			y2="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(26.667 9.6)"
			x1="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(26.667 13.867)"
			x1="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(26.667 18.133)"
			x1="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(26.667 22.4)"
			x1="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(9.599 26.667)"
			y2="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(13.867 26.667)"
			y2="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(18.133 26.667)"
			y2="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(22.4 26.667)"
			y2="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(2.133 9.6)"
			x1="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(2.133 13.867)"
			x1="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(2.133 18.133)"
			x1="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<svg:line
			class="stroke-width-2 strokeable"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(2.133 22.4)"
			x1="3.2"
			[ngStyle]="{
				'stroke': strokeColor
			}"
		/>

		<!--	inner rect	-->
		<svg:rect
			class="stroke-width-2 fillable strokeable"
			fill="none"
			height="8.533"
			stroke-linecap="round"
			stroke-linejoin="round"
			transform="translate(11.733 11.733)"
			width="8.533"
			[ngStyle]="{
				'fill': fillable ? fillColor : 'transparent',
				'stroke': strokeColor
			}"
		/>
  </svg:g>
</ng-template>

<ng-template #unlockedTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g transform="matrix(1, 0, 0, 1, 0.745896, -0.782196)">
		<svg:g transform="translate(284.000000, 430.000000)">
      <svg:path bx:origin="0.616 0.496"
								class="fillable"
								d="M -245.239 -408.951 L -248.192 -408.951 L -248.192 -415.018 C -248.192 -420.897 -253.212 -425.731 -259.315 -425.731 C -265.417 -425.731 -270.438 -420.897 -270.438 -415.018 L -270.438 -408.951 L -273.391 -408.951 L -273.391 -415.018 C -273.391 -422.508 -267.092 -428.576 -259.315 -428.576 C -251.539 -428.576 -245.239 -422.508 -245.239 -415.018 L -245.239 -408.951"
								transform="matrix(0.751796, -0.659395, 0.659395, 0.751796, 212.630083, -272.795886)"/>
      <svg:path class="fillable"
								d="M-239.2-374.1h-25.6c-2.6,0-4.8-2.2-4.8-4.8v-19.2c0-2.6,2.2-4.8,4.8-4.8h25.6     c2.6,0,4.8,2.2,4.8,4.8v19.2C-234.4-376.2-236.6-374.1-239.2-374.1L-239.2-374.1z M-264.8-399.7c-0.9,0-1.6,0.7-1.6,1.6v19.2     c0,0.9,0.7,1.6,1.6,1.6h25.6c0.9,0,1.6-0.7,1.6-1.6v-19.2c0-0.9-0.7-1.6-1.6-1.6H-264.8L-264.8-399.7z"/>
      <svg:path class="fillable" d="M-248.8-393.3c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2S-248.8-395-248.8-393.3     "/>
      <svg:polyline class="fillable" points="-251.2,-393.3 -252.8,-393.3 -254.4,-383.7 -249.6,-383.7 -251.2,-393.3    "/>
    </svg:g>
	</svg:g>
</ng-template>

<ng-template #uploadTpl xmlns:svg="http://www.w3.org/2000/svg">

	<!-- arrow head -->
	<svg:path
		class="strokeable stroke-width-2"
		d="M0,5.6H5.6V0"
		fill="none"
		stroke-linecap="round"
		stroke-linejoin="round"
		transform="translate(11.96 9.42) rotate(-135)"
	/>

	<!-- arrow line	-->
	<svg:line
		class="strokeable stroke-width-2"
		fill="none"
		stroke-linecap="round"
		transform="translate(12 0)"
		y1="12"
	/>

	<!-- rect	-->
	<svg:path
		class="strokeable stroke-width-2"
		d="M2,0H20a2,2,0,0,1,2,2V7a0,0,0,0,1,0,0H0A0,0,0,0,1,0,7V2A2,2,0,0,1,2,0Z"
		fill="none"
		stroke-linejoin="round"
		transform="translate(1 16)"
	/>

	<!-- dot	-->
	<svg:rect
		class="fillable"
		height="2"
		stroke="none"
		transform="translate(18 18.5)"
		width="2"
	/>
</ng-template>

<ng-template #usageTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="
		{
			'strokeable': strokeable
		}"
		transform="translate(0.25)"
	>
		<!-- bottom line -->
    <svg:line
			class="strokeable stroke-width-2"
			stroke-linecap="round"
			transform="translate(0.75 21)"
			x2="22.5"
		/>

		<!-- chart line 1 -->
    <svg:line
			class="strokeable stroke-width-2"
			stroke-linecap="round"
			transform="translate(3 9)"
			y1="12"
		/>

		<!-- chart line 2 -->
    <svg:line
			class="strokeable stroke-width-2"
			stroke-linecap="round"
			transform="translate(7.5 4.5)"
			y1="16.5"
		/>

		<!-- chart line 3 -->
    <svg:line
			class="strokeable stroke-width-2"
			stroke-linecap="round"
			transform="translate(12 6)"
			y1="15"
		/>

		<!-- chart line 4 -->
    <svg:line
			class="strokeable stroke-width-2"
			stroke-linecap="round"
			transform="translate(16.5 9)"
			y1="12"
		/>

		<!-- chart line 5 -->
    <svg:line
			class="strokeable stroke-width-2"
			stroke-linecap="round"
			transform="translate(21 3)"
			y1="18"
		/>
	</svg:g>
</ng-template>

<ng-template #usersTpl xmlns:svg="http://www.w3.org/2000/svg">
	<svg:g
		[ngClass]="
		{
			'strokeable': strokeable
		}"
	>
		<svg:path d="m10.78,131.14l101.71,0a5.57,5.57 0 0 0 5.51,-5.64c0,-8.2 0.29,-9.19 -0.15,-9.17l-39.55,-21.15c13.24,-10.73 13.42,-31.11 13.42,-32.04c0,-21.58 0,-21.68 0,-21.78a31.19,31.19 0 0 0 -29.9,-23.07a31.64,31.64 0 0 0 -30.21,23.06c0,0.1 0,21.78 0,21.78c0,0.94 0.16,21.81 13.29,32.09l-39.64,21.11c-0.58,0.33 0,0.95 0,9.17a5.58,5.58 0 0 0 5.52,5.64z"/>
		<svg:path d="m122.15,94.42l17.82,0a4.26,4.26 0 0 0 4,-4.47c0,-6.51 0.07,-7 -0.37,-7.27l-28.93,-15.61c-0.14,-1 -1.82,-3.47 0,-6c5.5,-7.5 7.63,-7.5 10.18,-16.91a51.11,51.11 0 0 0 0,-20.83a24,24 0 0 0 -21.67,-18.3a26.1,26.1 0 0 0 -15.44,4.79"/>
	</svg:g>
</ng-template>

